module.exports = __webpack_public_path__ + "static/media/Coins_Mail_Icon@3x.03bebee4.png";